import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Cookie } from '../../../../app/base/utils';
import { ApiServices } from '../../../../app/base/service/apiService';
import { API_ROUTE_CONTROLLER } from '../../../../service/route';
import { setProducts } from '../../../../store/constant';
import { updateLogin, updateLoginCred } from '../../../../store/login';
import { LoginService } from '../../../../service/login';
import ViewInvoiceBot from './invoice_detail_bot';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import Loaders from '../../../loader';

const ls = new LoginService();

const InvoiceBot = () => {
    const [isLoader, setLoader] = useState<boolean>(true);
    const [urlSplit, setUrlSpilt] = useState<any>({});
    const [planServices, setPlanServices] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    async function parseAndDecodeUrl(url) {
        const result = {};
        const queryString = url.split('?')[1] || '';
        queryString.split('&').forEach(pair => {
            if (!pair) return;
            const [rawKey, rawValue = ''] = pair.split('=');
            const key = decodeURIComponent(rawKey);
            const valString = decodeURIComponent(rawValue);
            // Attempt to Base64-decode
            let decoded = valString;
            try {
                decoded = atob(valString);
            } catch {
                // If not valid Base64, keep original
                decoded = valString;
            }
            // Try parsing JSON, fallback to plain text
            let parsed;
            try {
                parsed = JSON.parse(decoded);
            } catch {
                parsed = decoded;
            }
            result[key] = parsed;
        });
        return result;
    }

    const getBillServicePlan = async (data) => {
        const _url = API_ROUTE_CONTROLLER.UrgetBillServicePlan;
        const _body = {
            company_id: data?.detail?.companyId,
        };
        const res = await ApiServices.post(_body, _url);
        dispatch(setProducts(res.data.result))
        setPlanServices(res.data.result[0]);
        return res.data.result;
    };
    const loginApi = async (data) => {
        const res = await ls.login(data?.detail?.email.trim(), data?.detail?.password.trim(), false);
        if (res && res.length) {
            if (res[0].errcode == 0) {
                dispatch(updateLogin(res[0]));
                dispatch(updateLoginCred(res[0]))
            }
            setLoader(false)
        }
    }
    useEffect(() => {
        const url = window.location.href;
        const init = async () => {
            let newUrlSpilt: any = await parseAndDecodeUrl(url);
            console.log("newUrlSpilt", newUrlSpilt);
            if (!newUrlSpilt?.type || !newUrlSpilt?.detail) {
                Cookie.clear();
                navigate('/');
                return;
            }
            await loginApi(newUrlSpilt);
            setUrlSpilt(newUrlSpilt);
            const getBillService = await getBillServicePlan(newUrlSpilt);

        }
        init();
    }, [window.location.href])
    const jsonStr = JSON.stringify({
        "domainId": 20140,
        "company_id": 20213,
        "email": "naxosos937@mogash.com",
        "password": "Vectone@123",
        "firstName": "testt",
        "fromdate": "2025-08-29 00:00:00",
        "todate": "2025-09-01 00:00:00",
        "datefilter": 4,
    });
    const encoded = btoa(jsonStr);
    console.log("encodedd", encoded)
    return (
        <>
            {
                urlSplit?.type == "invoice" && !isLoader &&
                <>
                    <Row className="breadcrumbarea breadlinkte">
                        <Col sm={12}>
                            <h4>Invoice Management</h4>
                            <p>View your billing details.</p>
                        </Col>
                    </Row>

                    <Row className="nopadding">
                        <Col sm={12} className="nopadding tablecontenttab">
                            <ViewInvoiceBot urlSplit={urlSplit} />
                        </Col>
                    </Row>
                </>
            }
            {
                isLoader && <Loaders/>
            }

        </>
    )
}

export default InvoiceBot